import { cn } from "@/lib/utils";

const variantClasses = {
  live: "status-badge status-badge-live",
  estimated: "status-badge status-badge-estimated",
  benchmark: "status-badge status-badge-benchmark",
  neutral: "status-badge status-badge-neutral",
};

export const PremiumStatusBadge = ({ label, variant = "neutral", className, testId }) => {
  return (
    <span className={cn(variantClasses[variant] || variantClasses.neutral, className)} data-testid={testId}>
      {label}
    </span>
  );
};